import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import {MdKeyboardArrowRight} from '../../assets/icons/icons';
import edukryt from '../../assets/images/logo.png';
import blurb from '../../assets/images/blurb.png';
import { useSelector } from 'react-redux';
import logo_light from '../../assets/images/partholight.png';
import { useParams } from 'react-router-dom';
import { courses, product_category} from '../../axios/api/product_category';

import {
    FaFacebookF,
    FaYoutube,
    FaLinkedin,
    FaInstagram,
    FaTwitter
    } from "react-icons/fa";


export default function Footer() {

    const footerData = useSelector((state) => state.websiteReducer.data.data);
    const [products, setProducts] = useState();
    const {cat_id} = useParams();
    const [pageNo, setPageNo] = useState(1);

    useEffect(()=>{
        fetchCourses();
    },[])

    
        const fetchCourses = async ()=>{
                const courseData = {
                    category_id: cat_id,
                    page:pageNo
                }
                const newData = await courses(courseData);
                //console.log(newData);
                if(newData.status === 200)
                    {
                        if(newData.data.status === 1)
                        {
        
                            
                            
                            const newProducts = newData.data.data.data;
                            
                            if(newProducts.length===0)
                            {
                                setProducts(null);
                            }
                            else{
                                setProducts(newProducts);
                            }
        
                            //console.log(newData.data.data.data);
        
                        }
                    }
                    else
                    {
                        if(newData.response.data.status === 0)
                        {
                            //let msg = newData.response.data.message;
        
                               
        
                        }
                    }
            }

    return (
        
        <footer className="footer bg-white text-black border-t border-gray-200">
        <div className="container mx-auto py-12 px-6">
            <div className="grid grid-cols-1 md:grid-cols-6 gap-8">
            {/* Logo + Social */}
            <div className="col-span-2">
                <img src="../images/Tutormate.png" alt="TutorMate Logo" className="w-32 mb-4" />
                <div className="flex space-x-4">
                <Link to="https://www.facebook.com/people/TutorMate/100063641752515/#" className="text-gray-600 hover:text-blue-600">
                    <FaFacebookF size={22} />
                </Link>
                <Link to="https://www.youtube.com/channel/UCM0vLQoCCio8KjbgL1g0I5g" className="text-gray-600 hover:text-red-600">
                    <FaYoutube size={22} />
                </Link>
                </div>
            </div>

            {/* Classes */}
            <div>
                <h5 className="font-semibold mb-4">CLASSES</h5>
                <ul className="submenu" >
                        {
                            
                            products ?
                            [...products ]
                            .sort((a, b) => {
                        // Extract class numbers from product names
                        const getClassNumber = (name) => {
                            const match = name.match(/CLASS\s*(\d+)/i) || name.match(/\b(\d+)\b/);
                            return match ? parseInt(match[1]) : 0;
                        };
                        
                        const getBoardPriority = (name) => {
                            // MH BOARD comes after regular classes
                            if (name.toLowerCase().includes('mh board')) return 2;
                            if (name.toLowerCase().includes('class')) return 1;
                            return 3;
                        };
                        
                        const aBoard = getBoardPriority(a.product_name);
                        const bBoard = getBoardPriority(b.product_name);
                        
                        // First sort by board type
                        if (aBoard !== bBoard) {
                            return aBoard - bBoard;
                        }
                        
                        // Then sort by class number (ascending)
                        const aClass = getClassNumber(a.product_name);
                        const bClass = getClassNumber(b.product_name);
                        return aClass - bClass;
                    }).map((item, index)=>(
                                <>
                                    {
                                        index===0?
                                        <li className="ui-components px-1" key={index}><Link to={"/syllabus/"+item.slug} className="sub-menu-item">{item.product_name}</Link></li>
                                        :<li className="ui-components" key={index}><Link to={"/syllabus/"+item.slug} className="sub-menu-item">{item.product_name}</Link></li>
                                    }
                                    
                                </>
                            )): ''
                        }
                        
                        
                </ul>
            </div>

            {/* Exams */}
            <div>
                <h5 className="font-semibold mb-4">EXAMS</h5>
                <ul className="space-y-2 text-sm">
                    <li className='px-1'><Link to="/exam">JEE Main</Link></li>
                    <li><Link to="/jee_advance">JEE Advanced</Link></li>
                    <li><Link to="/neet">NEET</Link></li>
                </ul>
            </div>

            {/* About & Contact */}
            <div>
                <h5 className="font-semibold mb-4">ABOUT US</h5>
                <ul className="space-y-2 text-sm">
                <li><Link to="/page/about-us">Our Story</Link></li>
                </ul>
                <h5 className="font-semibold mt-6 mb-4">CONTACT US</h5>
                <ul className="space-y-2 text-sm">
                <li><Link to="/contact-us">Locations</Link></li>
                </ul>
            </div>

            {/* Careers & Customer Stories */}
            <div>
                <h5 className="font-semibold mb-4">CAREERS</h5>
                    <ul className="space-y-2 text-sm">
                        <li className='px-1'><Link to="/comming">Values</Link></li>
                        <li><Link to="/comming">Internships</Link></li>
                        <li><Link to="/comming">Jobs</Link></li>
                        </ul>
                        <h5 className="font-semibold mt-6 mb-4">CUSTOMER STORIES</h5>
                        <ul className="space-y-2 text-sm">
                        <li className='px-1'><Link to="/comming">Pedagogy</Link></li>
                        <li><Link to="/comming">Press</Link></li>
                        <li><Link to="/comming">FAQ's</Link></li>
                        <li><Link to="/blog">Blog</Link></li>
                    </ul>
            </div>
            </div>
        </div>

        {/* Bottom Links */}
        <div className="border-t border-gray-300 py-4 text-center text-sm">
            <ul className="flex justify-center space-x-4">
            <li className='px-1'><Link to="/terms">Terms Of Service</Link></li>
            <li><Link to="/page/privacy-policy">Privacy Policy</Link></li>
            {/* <li><Link to="/return">Return Policy</Link></li> */}
            </ul>
        </div>
        </footer>
    )
}
